<template>
  <div class="job-title-ranks-bar my-3" dir="rtl">
    <div class="is-flex is-align-items-center is-justify-content-space-between is-flex-wrap-wrap">
      <span class="is-size-7 job-title-ranks-owner">{{ ownerText }}</span>
      <div class="is-flex is-align-items-center">
        <span v-if="dirty" class="tag is-warning is-light ml-3 job-title-ranks-dirty">{{ texts.ranksUnsaved }}</span>
        <button
          type="button"
          class="button is-small is-info job-title-ranks-save"
          :class="{ 'is-loading': saving }"
          :disabled="!dirty || saving"
          @click="$emit('save')"
        >
          {{ texts.saveRanks }}
        </button>
      </div>
    </div>
    <p v-if="message" class="help is-danger job-title-ranks-message">{{ message }}</p>
  </div>
</template>

<script>
import { TEXTS } from '@/custom/classes/applicant_job_titles.js'

export default {
  name: 'JobTitleRanksBar',
  props: {
    ownerText: { type: String, required: true },
    dirty: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    message: { type: String, default: '' }
  },
  data () {
    return { texts: TEXTS }
  }
}
</script>
